import { TransactionsState, TransactionsActionTypes, transactionsActionNames } from './types';

const initialState: TransactionsState = {
  count: 0,
  downloadSuccess: false,
  exportable: true,
  allFileTypes: [],
  ajaxRequestCancelTokenForCount: null,
  detailsExpanded: [],
  subComponentRenderringFlag: false,
  loadingFlag: false,
};

export const transactionsReducer = (
  state: TransactionsState = initialState,
  action: TransactionsActionTypes,
): TransactionsState => {
  switch (action.type) {
    case transactionsActionNames.SET_SUBCOMPONENT_RENDERRING_FLAG: {
      return {
        ...state,
        subComponentRenderringFlag: action.payload,
      };
    }
    case transactionsActionNames.SET_TOTAL_COUNT: {
      return {
        ...state,
        count: action.payload,
      };
    }
    case transactionsActionNames.SET_EXPORTABLE: {
      return {
        ...state,
        exportable: action.payload,
      };
    }
    case transactionsActionNames.SET_ALL_FILE_TYPES: {
      return {
        ...state,
        allFileTypes: action.payload,
      };
    }

    case transactionsActionNames.SET_DETAILS: {
      return {
        ...state,
        detailsExpanded: action.payload,
      };
    }
    case transactionsActionNames.CLEAR_DETAILS: {
      return {
        ...state,
        detailsExpanded: [],
      };
    }
    case transactionsActionNames.SET_LOADING_FLAG: {
      return {
        ...state,
        loadingFlag: action.payload,
      };
    }
    default:
      return state;
  }
};
